import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { FilePdf, DownloadSimple } from "@phosphor-icons/react";

export async function downloadStatement(url, filename) {
  const res = await api.get(url, { responseType: "blob" });
  const href = URL.createObjectURL(res.data);
  const a = Object.assign(document.createElement("a"), { href, download: filename });
  document.body.appendChild(a); a.click(); a.remove();
  URL.revokeObjectURL(href);
}

export default function Statements({ basePath = "/statements", title = "Royalty Statements" }) {
  const [periods, setPeriods] = useState(null);
  const [busy, setBusy] = useState("");

  useEffect(() => { api.get(basePath).then(({ data }) => setPeriods(data.periods)).catch(() => setPeriods([])); }, [basePath]);

  const get = async (period) => {
    setBusy(period);
    try { await downloadStatement(`${basePath}/${period}.pdf`, `asylum-statement-${period}.pdf`); }
    catch { toast.error("Could not generate statement"); }
    finally { setBusy(""); }
  };

  if (!periods) return null;
  return (
    <section className="border border-zinc-800" data-testid="statements-section">
      <div className="flex items-center justify-between px-6 py-4 border-b border-zinc-800 bg-zinc-950">
        <div className="flex items-center gap-2"><FilePdf size={14} className="text-red-500" /><span className="text-[10px] tracking-[0.2em] uppercase text-zinc-500">{title}</span></div>
        {periods.length > 0 && (
          <button onClick={() => get("all")} disabled={!!busy} data-testid="statement-download-all" className="text-[10px] tracking-[0.2em] uppercase border border-zinc-700 px-3 py-1.5 hover:border-white inline-flex items-center gap-1 disabled:opacity-40">
            <DownloadSimple size={12} /> All-time PDF
          </button>
        )}
      </div>
      {periods.length === 0 ? (
        <div className="p-8 text-xs text-zinc-500" data-testid="statements-empty">Statements appear here once stores report your first streams.</div>
      ) : (
        <div className="divide-y divide-zinc-800">
          {periods.map((p) => (
            <div key={p.period} className="flex flex-wrap items-center gap-4 px-6 py-3 row-hover text-sm" data-testid={`statement-row-${p.period}`}>
              <div className="font-display text-lg uppercase tracking-tight w-40">{p.label}</div>
              <div className="text-[10px] tracking-widest uppercase text-zinc-500 flex-1">{p.releases} release{p.releases === 1 ? "" : "s"} · {p.streams.toLocaleString()} streams · ${p.gross.toFixed(2)} gross</div>
              <button onClick={() => get(p.period)} disabled={!!busy} data-testid={`statement-download-${p.period}`} className="text-[10px] tracking-[0.2em] uppercase bg-red-600 text-white px-4 py-2 btn-brutal btn-brutal-red inline-flex items-center gap-1 disabled:opacity-40">
                <DownloadSimple size={12} weight="bold" /> {busy === p.period ? "Building…" : "PDF"}
              </button>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
